import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
// arcgis
import WebMap from "@arcgis/core/WebMap";
import MapView from "@arcgis/core/views/MapView";
import Zoom from "@arcgis/core/widgets/Zoom";
import Point from "@arcgis/core/geometry/Point";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
// components
import SideMenu from "src/components/UI/Home/Main/SideMenu";
import BasicCard from "src/components/UI/LeftCard/BasicCard";
import PickerMessage from "src/components/UI/Picker/PickerMessage";
import Notification from "src/components/UI/Shared/Notification";
import { HeaderSimple } from "src/layouts/_common";
import Widget from "src/components/UI/Drawer-Widget/widget";
import Layers from "src/components/UI/Home/Menu/Layers";
import Printt from "src/components/UI/Print/Print";
import LLG from "src/components/UI/lat&long/LLG";
import { _GetUrl, _GetTitle } from "src/components/UI/Shared/handler";
// config
import { PanelPaths } from "src/layouts/_common/config";
import { Symbol } from "src/config/symbol";
import user from "src/components/UI/Shared/user";
// animation
import IntroAnimation from "src/assets/animations/Animation - Intro.json";
// assets
import DotLottie from "src/components/UI/Shared/DotLottie";
import logo_intro from "src/assets/images/logo-white.png";
import styles from "src/components/BaseMap/assets/scss/BaseMap.module.scss";
import classes from "src/components/BaseMap/assets/scss/myMap.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";
// Data
import Store from "src/data/store";
const store = Store.getInstance();

type Props = {
  children: React.ReactNode;
};

const BaseMap = ({ children }: Props) => {
  const dispatch = useDispatch();
  const notification = useSelector((state: any) => state.app.Notification);
  const activePanel = useSelector((state: any) => state.app.activePanel);
  const pickerModeEnabled = useSelector(
    (state: any) => state.app.pickerModeEnabled
  );
  const mobileMode = useSelector((state: any) => state.app.mobileMode);
  let navigate = useNavigate();
  const pathname = window.location.pathname;
  const viewRef = useRef<any>(null);
  const [showIntroGif, setShowIntroGif] = useState(true);
  const [terminateIntro, setTerminateIntro] = useState(false);
  const [openPickerMessage, setOpenPickerMessage] = useState(false);
  const [pickedCoordinates, setPickedCoordinates] = useState({
    latitude: 0,
    longitude: 0,
  });

  const opts = {
    duration: 500,
  };

  const viewLoadedHandler = () => {
    if (store.MapView) {
      var zoom = new Zoom({
        view: store.MapView,
      });
      store.MapView?.ui.add(zoom, "bottom-left");

      if (zoom.container) {
        const container_ = zoom.container as HTMLElement;
        container_.classList.add(classes.zoomContainer);
      }

      navigator.geolocation.getCurrentPosition(function (position) {
        if (position) {
          store.MapView?.goTo(
            {
              center: [position.coords.longitude, position.coords.latitude],
              zoom: 10,
            },
            opts
          );
        }
      });
    }
  };

  const initializeMap = useCallback(() => {
    const map = new WebMap({
      portalItem: {
        id: "042f5e5c096b4cd2918ae07fbf7049f7",
      },
    });

    store.MapView = new MapView({
      container: viewRef.current,
      map,
      ui: {
        components: ["attribution"],
      },
      constraints: { minZoom: 2 },
    });

    store.MapView.when(() => {
      viewLoadedHandler();
    });
  }, [viewLoadedHandler]);

  const handleClosePickerMessage = () => {
    dispatch(
      appActions.setSearchString({
        menu1: "",
        menu2: "",
        menu3: "",
        menu4: "",
        menu5: "",
        menu6: "",
      })
    );
    setOpenPickerMessage(false);
    dispatch(appActions.setPickerModeEnabled(false));
    navigate("../..");
  };
  useEffect(() => {
    if (pathname === "/Geo/layers")
      dispatch(appActions.setActivePanel("layers"));
    else if (pathname === `/Geo/${_GetUrl(3, 0)}`)
      dispatch(appActions.setActivePanel("drawing"));
    else if (pathname === `/Geo/${_GetUrl(3, 1)}`)
      dispatch(appActions.setActivePanel("printing"));
    else if (
      pathname === `/Geo/${_GetUrl(2, 0)}` ||
      pathname === `/Geo/${_GetUrl(2, 1)}` ||
      pathname === `/Geo/${_GetUrl(2, 2)}`
    )
      dispatch(appActions.setActivePanel("generator"));
  }, [pathname]);
  useEffect(() => {
    if (viewRef && viewRef.current) {
      initializeMap();
    }
  }, [terminateIntro]);
  useEffect(() => {
    if (!showIntroGif) {
      const introDiv = document.querySelector(".intro");
      introDiv?.classList.add(styles.introDivFade);
      const timer = setTimeout(() => {
        setTerminateIntro(true);
      }, 750);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [showIntroGif]);
  useEffect(() => {
    const email = user.parseUserEmail();
    console.log(email);
    if (email) {
      user.getUserCredits(email).then((result: number) => {
        dispatch(appActions.setCurrentBalance(result));
      });
    }
    const timer = setTimeout(() => {
      setShowIntroGif(false);
    }, 4250);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  const clickHandler = (
    event: __esri.ViewClickEvent,
    graphicsLayer: GraphicsLayer | undefined
  ) => {
    graphicsLayer?.removeAll();
    const longitude = event.mapPoint.longitude;
    const latitude = event.mapPoint.latitude;

    setPickedCoordinates({
      latitude: latitude,
      longitude: longitude,
    });

    setOpenPickerMessage(true);
    const point = new Point({
      longitude: longitude,
      latitude: latitude,
      spatialReference: new SpatialReference({
        wkid: 4326,
      }),
    });

    const graphic = new Graphic({
      geometry: point,
      symbol: Symbol.point,
    });

    graphicsLayer?.add(graphic);
  };
  let handler: IHandle | undefined;
  useEffect(() => {
    if (pickerModeEnabled === true) {
      const pickerLayer = store.MapView?.map.layers.toArray().filter((x) => {
        return x.id === "data_generator-lat_long";
      })[0] as GraphicsLayer;
      if (!pickerLayer)
        store.createGraphicsLayer(_GetTitle(2, 3), "data_generator-lat_long");

      handler = store.MapView?.on("click", (event) => {
        clickHandler(event, pickerLayer ? pickerLayer : store.graphicsLayer);
      });
    } else if (pickerModeEnabled === false) {
      handler = store.MapView?.on("click", (event) => {
        event.stopPropagation();
      });
    }
  }, [pickerModeEnabled]);
  return (
    <div className={styles.root}>
      {!terminateIntro ? (
        <>
          <div className={`${styles.introDiv} intro`}>
            <DotLottie animation={IntroAnimation} />
            <img
              src={logo_intro}
              style={{
                width: !mobileMode ? "15rem" : "12rem",
                zIndex: "99999",
                display: "flex",
                position: "absolute",
                bottom: !mobileMode ? "8rem" : "16rem",
              }}
            />
          </div>
        </>
      ) : (
        <>
          <BasicCard />
          <Widget />
          <Layers />
          <Printt />
          <LLG />
          <div
            ref={viewRef}
            style={{
              width: activePanel ? "calc(100vw - 14.45rem)" : "100vw",
              height: "100vh",
              padding: "0",
              margin: "0",
            }}
            className={`${pickerModeEnabled ? styles.customCursor : ""}`}
          >
            <HeaderSimple
              inHome={PanelPaths.includes(pathname.toLocaleLowerCase())}
              onClosePickerMode={
                pickerModeEnabled === true ? handleClosePickerMessage : () => {}
              }
            />

            <div style={{ position: "absolute", top: "60px", right: "10px" }}>
              {!mobileMode && (
                <SideMenu
                  onClosePickerMode={
                    pickerModeEnabled === true
                      ? handleClosePickerMessage
                      : () => {}
                  }
                />
              )}
            </div>
          </div>
        </>
      )}
      {children}
      <PickerMessage
        open={openPickerMessage}
        onClose={handleClosePickerMessage}
        pickedCoordinates={pickedCoordinates}
      />
      {notification.open && <Notification />}
    </div>
  );
};

export default BaseMap;
